import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

import user from './user';
import app from './app';

const store = {
  user,
  app,
};

export default store;

export function useStore<T extends keyof typeof store>(name: T) {
  return useContext<Record<string, (typeof store)[typeof name]>>(MobXProviderContext)[name];
}
